module.exports = __webpack_public_path__ + "57cecd4440ab99134f06cd444485f5a5.jpg";